// This enum describes authentication types saved on server.
export enum AuthenticationType {
    SkyKickAuth = 0,
    M365Auth = 1,
    ConnectWiseSso = 2
}
